import { useDraftOrders } from "../../../../hooks/api/v2/useDraftOrders";
import { useUnifiedCheckoutBasketList } from "../../../../hooks/api/v2/unified-checkout-basket/useUnifiedCheckoutBaskets";
import { isPromotionalOrderItem } from "../../../stockList/categoryPage/Storefront/StorefrontPromotion/isPromotionalOrderItem";

export const useCartSummary = ({
  showDeliveredBySellarFeatures,
  includeStorefrontDrafts = true,
}: {
  showDeliveredBySellarFeatures: boolean;
  includeStorefrontDrafts?: boolean;
}) => {
  const { orders: storefrontDraftOrders = [] } = useDraftOrders();
  const basketsQuery = useUnifiedCheckoutBasketList();
  const baskets = basketsQuery.data ?? [];
  const supplierItemCount = (
    includeStorefrontDrafts ? storefrontDraftOrders : []
  ).reduce(
    (count, order) =>
      count +
      (order.OrderItems?.reduce(
        (quantity, item) =>
          quantity + (isPromotionalOrderItem(item) ? 0 : item.quantity),
        0,
      ) ?? 0),
    0,
  );

  const deliveredBySellarItemCount = showDeliveredBySellarFeatures
    ? baskets.reduce(
        (count, basket) =>
          count +
          basket.DraftOrders.reduce(
            (orderCount, order) =>
              orderCount +
              order.Items.reduce(
                (quantity, item) =>
                  quantity + (item.PromotionRewardItemId ? 0 : item.quantity),
                0,
              ),
            0,
          ),
        0,
      )
    : 0;
  const totalItemCount = supplierItemCount + deliveredBySellarItemCount;

  return {
    supplierItemCount,
    deliveredBySellarItemCount,
    totalItemCount,
    baskets,
  };
};
